/**
 * Page à retrouver après connexion (SAAS-1266).
 *
 * @remarks
 * Le chemin de retour voyage dans l'URL de `/login` (`?redirect=…`), donc
 * n'importe qui peut en fabriquer un. Sans contrôle, `?redirect=https://ailleurs`
 * enverrait l'utilisateur fraîchement connecté sur un autre site (open
 * redirect) : seul un chemin de l'app est accepté.
 */

const REDIRECT_PARAM = 'redirect';

// Origine fictive : sert seulement à résoudre le chemin comme le ferait le
// navigateur, puis à vérifier qu'il ne change pas d'origine.
const BASE = 'https://app.invalid';

/**
 * `value` s'il désigne une page de l'app, sinon `null`.
 *
 * Résolu avec `URL` plutôt que testé à la main : le navigateur retire tabulations
 * et retours à la ligne et lit `\` comme `/`, si bien que `/\t/ailleurs` ou
 * `/\ailleurs` deviennent `//ailleurs` — un autre site.
 */
export function safeRedirect(value: string | null): string | null {
  if (value?.startsWith('/') !== true) return null;
  let url: URL;
  try {
    url = new URL(value, BASE);
  } catch {
    return null;
  }
  if (url.origin !== BASE || url.pathname === '/login') return null;
  return `${url.pathname}${url.search}${url.hash}`;
}

/** Le chemin de retour lu dans l'URL de `/login`, s'il est sûr. */
export function redirectFromSearch(search: URLSearchParams): string | null {
  return safeRedirect(search.get(REDIRECT_PARAM));
}

/** `/login`, avec la page à retrouver après connexion quand elle est sûre. */
export function loginPath(returnTo?: string): string {
  const target = safeRedirect(returnTo ?? null);
  return target === null ? '/login' : `/login?${REDIRECT_PARAM}=${encodeURIComponent(target)}`;
}
